/** 文件上传及下载API */
import type { FlatResponseData } from '@sa/axios';
import type { Api } from '@/typings/api';
import { get, post } from '../../request';
const prefix = '/file';

/** 生成预上传URL */
export const generatePresignedUrl: (params: {
  /** 数据ID */
  objectId: string;
  /** 业务类型ID */
  bizAttachmentType: string;
  /** 文件名 */
  filename: string;
  /** 文件类型 */
  mime?: string;
}) => Promise<FlatResponseData<Api.Common.GeneratePresignedUrlResult>> = params => {
  return post(`${prefix}/generatePresignedUrl`, params);
};

/** 生成预下载URL */
export const generateDownloadUrl: (
  url: string
) => Promise<FlatResponseData<Api.Common.GeneratePresignedUrlResult>> = attachmentId => {
  return get(`${prefix}/generateDownloadUrl`, {
    attachmentId
  });
};

/** 保存客户端上传文件信息 */
export const saveRemoteFile: (params: {
  /** 业务类型ID */
  bizAttachmentType: string;
  /** 文件名 */
  filename: string;
}) => Promise<FlatResponseData<any>> = params => {
  return post(`${prefix}/saveRemoteFile`, params);
};

export default {
  generatePresignedUrl,
  generateDownloadUrl,
  saveRemoteFile
};
